// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"413ec22b","513":"c972f119","703":"5b6f38d9","787":"4fd316b1"}[chunkId] + ".chunk.js";
};